import mutations from './mutation';
import getters from './getter';
import actions from './action'
export default {
  state() {
    return {
      userIdMiddlewareAuth: null,
      tokenMiddlewareAuth: null,
      displayNameMiddlewareAuth: '',
      emailMiddlewareAuth: null,
      trustPCMiddlewareAuth:false,
      autologoutMiddlewareAuth: false,
      basicUserDataMiddlewareAuth:{},
			userNameMiddlewareAuth:null
    }
  },
  mutations,
  getters,
  actions
}
